/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_PermissionGroups
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

// Types
export type Administer_Calendar = 'Administer_Calendar';
export type Administrator = 'Administrator';
export type CenterSignIn_Manage = 'CenterSignIn_Manage';
export type Course_Contributor = 'Course_Contributor';
export type CourseEdit = 'CourseEdit';
export type CourseManageParticipants = 'CourseManageParticipants';
export type Course_Monitor = 'Course_Monitor';
export type Course_Owner = 'Course_Owner';
export type Course_Participant = 'Course_Participant';
export type Course_Patient = 'Course_Patient';
export type Course_Patient_Monitor = 'Course_Patient_Monitor';
export type CourseResultsView = 'CourseResultsView';
export type CourseSessionDebrief = 'CourseSessionDebrief';
export type CourseSessionStartJoin = 'CourseSessionStartJoin';
export type Course_Statistics_Report_View = 'Course_Statistics_Report_View';
export type Course_Total_Grades_View = 'Course_Total_Grades_View';
export type Course_Viewer = 'Course_Viewer';
export type CreateCourses = 'CreateCourses';
export type CreateScenarios = 'CreateScenarios';
export type CreateSessions = 'CreateSessions';
export type DebriefScenarioSessions = 'DebriefScenarioSessions';
export type Evaluation_Complete = 'Evaluation_Complete';
export type Evaluation_Completed_View = 'Evaluation_Completed_View';
export type Evaluation_EditComplete = 'Evaluation_EditComplete';
export type Evaluation_Grades_View = 'Evaluation_Grades_View';
export type Evaluation_Participant_Completed_View = 'Evaluation_Participant_Completed_View';
export type EvaluationTemplate_Fill_Complete = 'EvaluationTemplate_Fill_Complete';
export type EvaluationTemplate_Fill_EditComplete = 'EvaluationTemplate_Fill_EditComplete';
export type Internal_Control_Exams = 'Internal_Control_Exams';
export type Internal_MonitorExamSessions = 'Internal_MonitorExamSessions';
export type Internal_Recording_Annotation_Owner = 'Internal_Recording_Annotation_Owner';
export type Internal_Reservation_Owner = 'Internal_Reservation_Owner';
export type Internal_Reservation_Participant = 'Internal_Reservation_Participant';
export type Internal_Reservation_Request_Owner = 'Internal_Reservation_Request_Owner';
export type Internal_Users_Manager = 'Internal_Users_Manager';
export type ManageParticipants = 'ManageParticipants';
export type ManageSps = 'ManageSps';
export type Participant = 'Participant';
export type ReportAcrossSystem = 'ReportAcrossSystem';
export type Scenario_Contributor = 'Scenario_Contributor';
export type Scenario_Contributor_Results_View = 'Scenario_Contributor_Results_View';
export type Scenario_Course_Contributor_Results_View = 'Scenario_Course_Contributor_Results_View';
export type ScenarioCourseMonitor = 'ScenarioCourseMonitor';
export type ScenarioCourseOwner = 'ScenarioCourseOwner';
export type ScenarioCourseSessionStartJoin = 'ScenarioCourseSessionStartJoin';
export type ScenarioCourseViewer = 'ScenarioCourseViewer';
export type ScenarioEdit = 'ScenarioEdit';
export type Scenario_Owner = 'Scenario_Owner';
export type Scenario_Patient = 'Scenario_Patient';
export type ScenarioStartSession = 'ScenarioStartSession';
export type Scenario_Viewer = 'Scenario_Viewer';
export type Scoring_Evaluation_EditComplete = 'Scoring_Evaluation_EditComplete';
export type Scoring_Rubric_Fill_EditComplete = 'Scoring_Rubric_Fill_EditComplete';
export type SessionAnnotate = 'SessionAnnotate';
export type Session_Contributor = 'Session_Contributor';
export type Session_Contributor_Results_View = 'Session_Contributor_Results_View';
export type Session_Course_Contributor = 'Session_Course_Contributor';
export type Session_Course_Contributor_Results_View = 'Session_Course_Contributor_Results_View';
export type Session_Course_Viewer = 'Session_Course_Viewer';
export type SessionEdit = 'SessionEdit';
export type Session_Owner = 'Session_Owner';
export type Session_Participant = 'Session_Participant';
export type SessionParticipantAnnotate = 'SessionParticipantAnnotate';
export type SessionParticipantRecordingAnnotations = 'SessionParticipantRecordingAnnotations';
export type Session_Patient = 'Session_Patient';
export type Session_Patient_Annotate = 'Session_Patient_Annotate';
export type Session_Patient_View_All_Annotations = 'Session_Patient_View_All_Annotations';
export type Session_Patient_View_Session = 'Session_Patient_View_Session';
export type SessionRecordingAnnotations = 'SessionRecordingAnnotations';
export type Session_Release_View = 'Session_Release_View';
export type Session_Scenario_Contributor = 'Session_Scenario_Contributor';
export type Session_Scenario_Contributor_Results_View = 'Session_Scenario_Contributor_Results_View';
export type Session_Scenario_Viewer = 'Session_Scenario_Viewer';
export type Session_Viewer = 'Session_Viewer';
export type Sessions_Contributor_Evaluation_Create = 'Sessions_Contributor_Evaluation_Create';
export type StartAnySession = 'StartAnySession';
export type SystemAdmin = 'SystemAdmin';

export type PermissionGroup =
    | Administer_Calendar
    | Administrator
    | CenterSignIn_Manage
    | Course_Contributor
    | CourseEdit
    | CourseManageParticipants
    | Course_Monitor
    | Course_Owner
    | Course_Participant
    | Course_Patient
    | Course_Patient_Monitor
    | CourseResultsView
    | CourseSessionDebrief
    | CourseSessionStartJoin
    | Course_Statistics_Report_View
    | Course_Total_Grades_View
    | Course_Viewer
    | CreateCourses
    | CreateScenarios
    | CreateSessions
    | DebriefScenarioSessions
    | Evaluation_Complete
    | Evaluation_Completed_View
    | Evaluation_EditComplete
    | Evaluation_Grades_View
    | Evaluation_Participant_Completed_View
    | EvaluationTemplate_Fill_Complete
    | EvaluationTemplate_Fill_EditComplete
    | Internal_Control_Exams
    | Internal_MonitorExamSessions
    | Internal_Recording_Annotation_Owner
    | Internal_Reservation_Owner
    | Internal_Reservation_Participant
    | Internal_Reservation_Request_Owner
    | Internal_Users_Manager
    | ManageParticipants
    | ManageSps
    | Participant
    | ReportAcrossSystem
    | Scenario_Contributor
    | Scenario_Contributor_Results_View
    | Scenario_Course_Contributor_Results_View
    | ScenarioCourseMonitor
    | ScenarioCourseOwner
    | ScenarioCourseSessionStartJoin
    | ScenarioCourseViewer
    | ScenarioEdit
    | Scenario_Owner
    | Scenario_Patient
    | ScenarioStartSession
    | Scenario_Viewer
    | Scoring_Evaluation_EditComplete
    | Scoring_Rubric_Fill_EditComplete
    | SessionAnnotate
    | Session_Contributor
    | Session_Contributor_Results_View
    | Session_Course_Contributor
    | Session_Course_Contributor_Results_View
    | Session_Course_Viewer
    | SessionEdit
    | Session_Owner
    | Session_Participant
    | SessionParticipantAnnotate
    | SessionParticipantRecordingAnnotations
    | Session_Patient
    | Session_Patient_Annotate
    | Session_Patient_View_All_Annotations
    | Session_Patient_View_Session
    | SessionRecordingAnnotations
    | Session_Release_View
    | Session_Scenario_Contributor
    | Session_Scenario_Contributor_Results_View
    | Session_Scenario_Viewer
    | Session_Viewer
    | Sessions_Contributor_Evaluation_Create
    | StartAnySession
    | SystemAdmin;

// Constants
export const ADMINISTER_CALENDAR: PermissionGroup = 'Administer_Calendar' as const;
export const ADMINISTRATOR: PermissionGroup = 'Administrator' as const;
export const CENTER_SIGN_IN_MANAGE: PermissionGroup = 'CenterSignIn_Manage' as const;
export const COURSE_CONTRIBUTOR: PermissionGroup = 'Course_Contributor' as const;
export const COURSE_EDIT: PermissionGroup = 'CourseEdit' as const;
export const COURSE_MANAGE_PARTICIPANTS: PermissionGroup = 'CourseManageParticipants' as const;
export const COURSE_MONITOR: PermissionGroup = 'Course_Monitor' as const;
export const COURSE_OWNER: PermissionGroup = 'Course_Owner' as const;
export const COURSE_PARTICIPANT: PermissionGroup = 'Course_Participant' as const;
export const COURSE_PATIENT: PermissionGroup = 'Course_Patient' as const;
export const COURSE_PATIENT_MONITOR: PermissionGroup = 'Course_Patient_Monitor' as const;
export const COURSE_RESULTS_VIEW: PermissionGroup = 'CourseResultsView' as const;
export const COURSE_SESSION_DEBRIEF: PermissionGroup = 'CourseSessionDebrief' as const;
export const COURSE_SESSION_START_JOIN: PermissionGroup = 'CourseSessionStartJoin' as const;
export const COURSE_STATISTICS_REPORT_VIEW: PermissionGroup = 'Course_Statistics_Report_View' as const;
export const COURSE_TOTAL_GRADES_VIEW: PermissionGroup = 'Course_Total_Grades_View' as const;
export const COURSE_VIEWER: PermissionGroup = 'Course_Viewer' as const;
export const CREATE_COURSES: PermissionGroup = 'CreateCourses' as const;
export const CREATE_SCENARIOS: PermissionGroup = 'CreateScenarios' as const;
export const CREATE_SESSIONS: PermissionGroup = 'CreateSessions' as const;
export const DEBRIEF_SCENARIO_SESSIONS: PermissionGroup = 'DebriefScenarioSessions' as const;
export const EVALUATION_COMPLETE: PermissionGroup = 'Evaluation_Complete' as const;
export const EVALUATION_COMPLETED_VIEW: PermissionGroup = 'Evaluation_Completed_View' as const;
export const EVALUATION_EDIT_COMPLETE: PermissionGroup = 'Evaluation_EditComplete' as const;
export const EVALUATION_GRADES_VIEW: PermissionGroup = 'Evaluation_Grades_View' as const;
export const EVALUATION_PARTICIPANT_COMPLETED_VIEW: PermissionGroup = 'Evaluation_Participant_Completed_View' as const;
export const EVALUATION_TEMPLATE_FILL_COMPLETE: PermissionGroup = 'EvaluationTemplate_Fill_Complete' as const;
export const EVALUATION_TEMPLATE_FILL_EDIT_COMPLETE: PermissionGroup = 'EvaluationTemplate_Fill_EditComplete' as const;
export const INTERNAL_CONTROL_EXAMS: PermissionGroup = 'Internal_Control_Exams' as const;
export const INTERNAL_MONITOR_EXAM_SESSIONS: PermissionGroup = 'Internal_MonitorExamSessions' as const;
export const INTERNAL_RECORDING_ANNOTATION_OWNER: PermissionGroup = 'Internal_Recording_Annotation_Owner' as const;
export const INTERNAL_RESERVATION_OWNER: PermissionGroup = 'Internal_Reservation_Owner' as const;
export const INTERNAL_RESERVATION_PARTICIPANT: PermissionGroup = 'Internal_Reservation_Participant' as const;
export const INTERNAL_RESERVATION_REQUEST_OWNER: PermissionGroup = 'Internal_Reservation_Request_Owner' as const;
export const INTERNAL_USERS_MANAGER: PermissionGroup = 'Internal_Users_Manager' as const;
export const MANAGE_PARTICIPANTS: PermissionGroup = 'ManageParticipants' as const;
export const MANAGE_SPS: PermissionGroup = 'ManageSps' as const;
export const PARTICIPANT: PermissionGroup = 'Participant' as const;
export const REPORT_ACROSS_SYSTEM: PermissionGroup = 'ReportAcrossSystem' as const;
export const SCENARIO_CONTRIBUTOR: PermissionGroup = 'Scenario_Contributor' as const;
export const SCENARIO_CONTRIBUTOR_RESULTS_VIEW: PermissionGroup = 'Scenario_Contributor_Results_View' as const;
export const SCENARIO_COURSE_CONTRIBUTOR_RESULTS_VIEW: PermissionGroup = 'Scenario_Course_Contributor_Results_View' as const;
export const SCENARIO_COURSE_MONITOR: PermissionGroup = 'ScenarioCourseMonitor' as const;
export const SCENARIO_COURSE_OWNER: PermissionGroup = 'ScenarioCourseOwner' as const;
export const SCENARIO_COURSE_SESSION_START_JOIN: PermissionGroup = 'ScenarioCourseSessionStartJoin' as const;
export const SCENARIO_COURSE_VIEWER: PermissionGroup = 'ScenarioCourseViewer' as const;
export const SCENARIO_EDIT: PermissionGroup = 'ScenarioEdit' as const;
export const SCENARIO_OWNER: PermissionGroup = 'Scenario_Owner' as const;
export const SCENARIO_PATIENT: PermissionGroup = 'Scenario_Patient' as const;
export const SCENARIO_START_SESSION: PermissionGroup = 'ScenarioStartSession' as const;
export const SCENARIO_VIEWER: PermissionGroup = 'Scenario_Viewer' as const;
export const SCORING_EVALUATION_EDIT_COMPLETE: PermissionGroup = 'Scoring_Evaluation_EditComplete' as const;
export const SCORING_RUBRIC_FILL_EDIT_COMPLETE: PermissionGroup = 'Scoring_Rubric_Fill_EditComplete' as const;
export const SESSION_ANNOTATE: PermissionGroup = 'SessionAnnotate' as const;
export const SESSION_CONTRIBUTOR: PermissionGroup = 'Session_Contributor' as const;
export const SESSION_CONTRIBUTOR_RESULTS_VIEW: PermissionGroup = 'Session_Contributor_Results_View' as const;
export const SESSION_COURSE_CONTRIBUTOR: PermissionGroup = 'Session_Course_Contributor' as const;
export const SESSION_COURSE_CONTRIBUTOR_RESULTS_VIEW: PermissionGroup = 'Session_Course_Contributor_Results_View' as const;
export const SESSION_COURSE_VIEWER: PermissionGroup = 'Session_Course_Viewer' as const;
export const SESSION_EDIT: PermissionGroup = 'SessionEdit' as const;
export const SESSION_OWNER: PermissionGroup = 'Session_Owner' as const;
export const SESSION_PARTICIPANT: PermissionGroup = 'Session_Participant' as const;
export const SESSION_PARTICIPANT_ANNOTATE: PermissionGroup = 'SessionParticipantAnnotate' as const;
export const SESSION_PARTICIPANT_RECORDING_ANNOTATIONS: PermissionGroup = 'SessionParticipantRecordingAnnotations' as const;
export const SESSION_PATIENT: PermissionGroup = 'Session_Patient' as const;
export const SESSION_PATIENT_ANNOTATE: PermissionGroup = 'Session_Patient_Annotate' as const;
export const SESSION_PATIENT_VIEW_ALL_ANNOTATIONS: PermissionGroup = 'Session_Patient_View_All_Annotations' as const;
export const SESSION_PATIENT_VIEW_SESSION: PermissionGroup = 'Session_Patient_View_Session' as const;
export const SESSION_RECORDING_ANNOTATIONS: PermissionGroup = 'SessionRecordingAnnotations' as const;
export const SESSION_RELEASE_VIEW: PermissionGroup = 'Session_Release_View' as const;
export const SESSION_SCENARIO_CONTRIBUTOR: PermissionGroup = 'Session_Scenario_Contributor' as const;
export const SESSION_SCENARIO_CONTRIBUTOR_RESULTS_VIEW: PermissionGroup = 'Session_Scenario_Contributor_Results_View' as const;
export const SESSION_SCENARIO_VIEWER: PermissionGroup = 'Session_Scenario_Viewer' as const;
export const SESSION_VIEWER: PermissionGroup = 'Session_Viewer' as const;
export const SESSIONS_CONTRIBUTOR_EVALUATION_CREATE: PermissionGroup = 'Sessions_Contributor_Evaluation_Create' as const;
export const START_ANY_SESSION: PermissionGroup = 'StartAnySession' as const;
export const SYSTEM_ADMIN: PermissionGroup = 'SystemAdmin' as const;

const LU_PermissionGroups = {
    ADMINISTER_CALENDAR,
    ADMINISTRATOR,
    CENTER_SIGN_IN_MANAGE,
    COURSE_CONTRIBUTOR,
    COURSE_EDIT,
    COURSE_MANAGE_PARTICIPANTS,
    COURSE_MONITOR,
    COURSE_OWNER,
    COURSE_PARTICIPANT,
    COURSE_PATIENT,
    COURSE_PATIENT_MONITOR,
    COURSE_RESULTS_VIEW,
    COURSE_SESSION_DEBRIEF,
    COURSE_SESSION_START_JOIN,
    COURSE_STATISTICS_REPORT_VIEW,
    COURSE_TOTAL_GRADES_VIEW,
    COURSE_VIEWER,
    CREATE_COURSES,
    CREATE_SCENARIOS,
    CREATE_SESSIONS,
    DEBRIEF_SCENARIO_SESSIONS,
    EVALUATION_COMPLETE,
    EVALUATION_COMPLETED_VIEW,
    EVALUATION_EDIT_COMPLETE,
    EVALUATION_GRADES_VIEW,
    EVALUATION_PARTICIPANT_COMPLETED_VIEW,
    EVALUATION_TEMPLATE_FILL_COMPLETE,
    EVALUATION_TEMPLATE_FILL_EDIT_COMPLETE,
    INTERNAL_CONTROL_EXAMS,
    INTERNAL_MONITOR_EXAM_SESSIONS,
    INTERNAL_RECORDING_ANNOTATION_OWNER,
    INTERNAL_RESERVATION_OWNER,
    INTERNAL_RESERVATION_PARTICIPANT,
    INTERNAL_RESERVATION_REQUEST_OWNER,
    INTERNAL_USERS_MANAGER,
    MANAGE_PARTICIPANTS,
    MANAGE_SPS,
    PARTICIPANT,
    REPORT_ACROSS_SYSTEM,
    SCENARIO_CONTRIBUTOR,
    SCENARIO_CONTRIBUTOR_RESULTS_VIEW,
    SCENARIO_COURSE_CONTRIBUTOR_RESULTS_VIEW,
    SCENARIO_COURSE_MONITOR,
    SCENARIO_COURSE_OWNER,
    SCENARIO_COURSE_SESSION_START_JOIN,
    SCENARIO_COURSE_VIEWER,
    SCENARIO_EDIT,
    SCENARIO_OWNER,
    SCENARIO_PATIENT,
    SCENARIO_START_SESSION,
    SCENARIO_VIEWER,
    SCORING_EVALUATION_EDIT_COMPLETE,
    SCORING_RUBRIC_FILL_EDIT_COMPLETE,
    SESSION_ANNOTATE,
    SESSION_CONTRIBUTOR,
    SESSION_CONTRIBUTOR_RESULTS_VIEW,
    SESSION_COURSE_CONTRIBUTOR,
    SESSION_COURSE_CONTRIBUTOR_RESULTS_VIEW,
    SESSION_COURSE_VIEWER,
    SESSION_EDIT,
    SESSION_OWNER,
    SESSION_PARTICIPANT,
    SESSION_PARTICIPANT_ANNOTATE,
    SESSION_PARTICIPANT_RECORDING_ANNOTATIONS,
    SESSION_PATIENT,
    SESSION_PATIENT_ANNOTATE,
    SESSION_PATIENT_VIEW_ALL_ANNOTATIONS,
    SESSION_PATIENT_VIEW_SESSION,
    SESSION_RECORDING_ANNOTATIONS,
    SESSION_RELEASE_VIEW,
    SESSION_SCENARIO_CONTRIBUTOR,
    SESSION_SCENARIO_CONTRIBUTOR_RESULTS_VIEW,
    SESSION_SCENARIO_VIEWER,
    SESSION_VIEWER,
    SESSIONS_CONTRIBUTOR_EVALUATION_CREATE,
    START_ANY_SESSION,
    SYSTEM_ADMIN,
} as const;

export default LU_PermissionGroups;
